export enum EFormTypeSplitBill {
  SLIDE = 'slide',
  MANUAL = 'manual',
}
